import moment from 'moment'

const formatDateWithHours = (date, format) => {
  return moment(date)
    .locale('pt-br')
    .format(format)
}

export default formatDateWithHours
